import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Apiservice } from '../../services/api.service';
import { Utenteservice } from '../../services/utente.service';
import { NicaAnagraficaComponent } from '../nica-anagrafica/nica-anagrafica.component';
import { OverlaySideFormService } from '../shared/overlay-side-form/overlay-side-form.service';
import { confirm } from 'devextreme/ui/dialog';
import { alert } from "devextreme/ui/dialog"
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-permessiutenti',
  templateUrl: './permessiutenti.component.html',
  styleUrls: ['./permessiutenti.component.css']
})
export class PermessiutentiComponent implements OnInit {
  @ViewChild('uPermessi', { static: true }) uPermessi: NicaAnagraficaComponent;
  @Input() itemData: any

  


  myFilter: string;
  Aziende
  filterValue: any = this.utenteService.GruppiFunzioni[0];
  moduli = [
    {
      text: 'Tutte Funzioni',
      id: 'A'
    },
    {
      text: 'Funzioni Contabilita',
      id: 'C'
    },
    {
      text: 'Funzioni Rifiuti',
      id: 'R'
    },
    {
      text: 'Funzioni Magazzino',
      id: 'M'
    },
    {
      text: 'Funzioni Definite come D',
      id: 'M'
    },
  ];
  currentAzienda: number;
  currentAccount: string;
  newAzienda: any = -1;
  itemsCopy:any[]=[]
  ArrCopiaPermessi:any [] ;
  isDisabled: boolean=true;
  isEdit: any;
  //?idAccount=9
  constructor(
    private spinner: NgxSpinnerService,
    private appService: Apiservice,
    private _overlaySideFormService: OverlaySideFormService,
    public utenteService: Utenteservice) { 
      
    }

  ngOnInit() {
    
    if(this.utenteService.temporaryPaste.source.toLowerCase()=='permessi_utente'){
      this.isDisabled=this.utenteService.temporaryPaste.data.length==0;
    }
    //this.isDisabled=this.utenteService.temporaryPaste.data.length>0;
    console.log("ITREM DATA ",this.itemData);
    //this.myFilter='?idAccount='+this.itemData[0].idTabRif 
    //this.utenteService.InfoDatiUtenteConnesso.aziendaSelected
    //this.Aziende=this.utenteService.InfoDatiUtenteConnesso.aziende

    this.currentAzienda = this.utenteService.InfoDatiUtenteConnesso.aziendaSelected;
    this.currentAccount = this.itemData[0].idTabRif;//this.utenteService.InfoDatiUtenteConnesso.idAccount;

    this.myFilter = '?idAccount=' + this.currentAccount
    this.myFilter += '&idAzienda=' + this.utenteService.InfoDatiUtenteConnesso.aziendaSelected;
    this.newAzienda = this.utenteService.InfoDatiUtenteConnesso.aziendaSelected;
    this.appService.GetApi("Azienda/GetAziendeByUser?idUser=" + this.currentAccount).then(result => {
      //let cc=
      this.Aziende = result;
      console.log("ecco le Aziende ", result);
    })


  }
  onAziendaChanged(e) {
    console.log("in change ", this.uPermessi.griglia.instance)
    console.log("in change EDIT STATO", this.uPermessi.griglia.instance.hasEditData())
    this.newAzienda = e.value;
    if (this.uPermessi.griglia.instance.hasEditData()) {

      //this.currentAzienda=e.value;
      this.uPermessi.griglia.instance.saveEditData();
      /*  
      this.myFilter='?idAccount='+this.currentAccount
      this.myFilter+='&idAzienda='+this.currentAzienda;        
      this.filterValue=this.utenteService.GruppiFunzioni[0];
      this.uPermessi.refresh();
      */
      // relegato a save
      /*
      this.uPermessi.griglia.instance.cancelEditData();
      this.myFilter='?idAccount='+this.currentAccount
      this.myFilter+='&idAzienda='+e.value;
      this.newAzienda=e.value;
      this.currentAzienda=e.value;
      this.uPermessi.refresh();
      this.filterValue=this.utenteService.GruppiFunzioni[0];
      */
    } else {
      this.uPermessi.griglia.instance.cancelEditData();
      this.newAzienda = e.value
      this.currentAzienda = e.value
      this.myFilter = '?idAccount=' + this.currentAccount
      this.myFilter += '&idAzienda=' + e.value;
      this.currentAzienda = e.value;
      this.uPermessi.refresh();
      this.filterValue = this.utenteService.GruppiFunzioni[0];
    }


  }
  optionalButtonClick2(e) {
    console.log("optionalButtonClick2 ", e)
    this.uPermessi.griglia.instance.cellValue(e.row.rowIndex, 'cancellazione', true)
    this.uPermessi.griglia.instance.cellValue(e.row.rowIndex, 'inserimento', true)
    this.uPermessi.griglia.instance.cellValue(e.row.rowIndex, 'modifica', true)
    this.uPermessi.griglia.instance.cellValue(e.row.rowIndex, 'visualizzazione', true)
    //e.row.data.cancellazione=true
  }
  validateDataFieldPrepared(e) {

  }
  checkGetAll(e) {
    let rispo = {
      items: []
    }
    rispo.items = e.data[0].funzioni;
    return rispo;
    console.log("In Permessi ", e.data[0].funzioni)
    return e.data[0].funzioni;
  }
  onFilterChanged(e) {
    if (e.value.id == 'A') {
      this.uPermessi.griglia.instance.clearFilter();
    } else
      this.uPermessi.griglia.instance.filter(['macroMenu', 'contains', e.value.id]);
    console.log("changed filter ", e)
  }
  AllEvent(e) {
    //onContentReady
    if (e.name == 'onContentReady') {
      if(this.uPermessi.griglia.instance.hasEditData()!=this.isEdit){
        this.isEdit=this.uPermessi.griglia.instance.hasEditData();
        console.log("In Edit ",this.isEdit)
        this.uPermessi.griglia.instance.repaint();
      }
      
      
    }

    if (e.name == 'preparaToolbar') {
      this.preparaToolbarCopiaIncolla(e)
    }
    if (e.name == 'onSaved') {
      //console.log("On Saved ", e)
      //console.log("Ecco i dati in griglia  On Saved ", this.uPermessi.griglia.instance.getDataSource());
    }
    if (e.name == 'onSaving') {
      this.uPermessi.griglia.instance.clearFilter();
      e.cancel = true;
      setTimeout(() => {

        e.cancel = true;
        let oldElementInGrid = this.uPermessi.griglia.instance.getDataSource().items();
        //console.log("Ecco i dati in griglia   ",oldElementInGrid);
        e.changes.forEach(element => {
          let obj = oldElementInGrid.find(x => x.id === element.key);
          if (obj) {
            const r = Object.keys(element.data); // Valori cambiati
            r.forEach(elementKey => {
              obj[elementKey] = element.data[elementKey]
            });
          }
        });
        let dataRecord = {
          id: 0,
          idAccount: this.currentAccount,
          idAzienda: this.currentAzienda,
          funzioni: oldElementInGrid
        }
        this.appService.ScriviPermessiUtente(dataRecord).then(response => {

          this.uPermessi.griglia.instance.cancelEditData();
          this.currentAzienda = this.newAzienda;
          this.myFilter = '?idAccount=' + this.currentAccount
          this.myFilter += '&idAzienda=' + this.currentAzienda;
          this.filterValue = this.utenteService.GruppiFunzioni[0];
          this.uPermessi.refresh();

          //this.currentAzienda=this.newAzienda
          /*
          this.myFilter='?idAccount='+this.currentAccount
          this.myFilter+='&idAzienda='+this.currentAzienda;        
          this.filterValue=this.utenteService.GruppiFunzioni[0];
          this.uPermessi.refresh();
          */
          this.spinner.hide();
        }).catch((err: HttpErrorResponse) => {

        });

      }, 200);

    }
  }
  checkIncolla(vv){
    return true;
  }
  preparaToolbarCopiaIncolla(e) {
    const that = this;
    //---------------------------    
    e.toolbarOptions.items.push({
      location: "after",
      widget: 'dxButton',
      cssClass: "",
      options: {
        icon: "fa fa-copy",
        disabled:that.isEdit,
        elementAttr: { title: "Copia Permessi" },
        onClick: function (e: any) {
          that.ArrCopiaPermessi = that.uPermessi.griglia.instance.getDataSource().items();
          
          that.utenteService.temporaryPaste.source='permessi_utente';
          that.utenteService.temporaryPaste.type='array';
          that.utenteService.temporaryPaste.title='Incolla Permessi Utenti';
          that.utenteService.temporaryPaste.data=that.ArrCopiaPermessi;

          console.log("Ho copiato ",that.uPermessi.griglia);
          //that.uPermessi.preparaToolbar(that.uPermessi.griglia);          
          that.isDisabled=false;
          that.uPermessi.griglia.instance.repaint();

          console.log("toolbar ",that.uPermessi.griglia.instance.option('toolbar'))
          // Copia Permessi
        }
      }
    });
    e.toolbarOptions.items.push({
      location: "after",
      widget: 'dxButton',
      cssClass: "bt_incolla",
      options: {
        icon: "paste",
        disabled:that.isDisabled,//that.todos$.subscribe() ,//.length==0,
        elementAttr: { title: "Incolla Permessi" },
        onClick: () => {
          if(this.utenteService.temporaryPaste.source.toLowerCase()!='permessi_utente'){
            return
          }
          if (this.utenteService.temporaryPaste.data.length == 0) return;
          let result = confirm("<i>La funzione sostituisce eventuali Permessi già presenti. Pocedere?</i>", "Attenzione!");
          result.then((dialogResult) => {
            if (dialogResult) {
              that.uPermessi.griglia.instance.getDataSource().store().load().done((allData)=>{  
                this.utenteService.temporaryPaste.data.forEach(element => { 
                  let r=allData.data.findIndex(elem=>elem.id==element.id)
                  if(r>-1){                  
                    that.uPermessi.griglia.instance.cellValue(r,'inserimento',element.inserimento)
                    that.uPermessi.griglia.instance.cellValue(r,'cancellazione',element.cancellazione)
                    that.uPermessi.griglia.instance.cellValue(r,'modifica',element.modifica)
                    that.uPermessi.griglia.instance.cellValue(r,'visualizzazione',element.visualizzazione)
                  }
                });               
             }); 
            }
          });
        }
      }
    });
    e.toolbarOptions.items.push({
      location: "after",
      widget: 'dxButton',
      options: {
        icon: "clearformat",
        //color: "red",
        elementAttr: { title: "Elimina Tutti i Permessi" },
        onClick: function (e: any) {
          let result = confirm("La funzione cancellerà tutti i permessi presenti. Procedere?", "Copia Permessi");
          result.then((dialogResult) => {
            if (dialogResult) {
              that.spinner.show;
              that.uPermessi.griglia.instance.getDataSource().store().load().done((allData)=>{  
                let r=-1;
                allData.data.forEach(element => {
                  r++;
                  that.uPermessi.griglia.instance.cellValue(r,'inserimento',false)
                  that.uPermessi.griglia.instance.cellValue(r,'cancellazione',false)
                  that.uPermessi.griglia.instance.cellValue(r,'modifica',false)
                  that.uPermessi.griglia.instance.cellValue(r,'visualizzazione',false)
                }); 
                  that.uPermessi.griglia.instance.saveEditData();

             }); 
            }
          });

        }
      }
    });

    //xxx
  }






}
